<template lang="pug" src="./custom-reviews-content.pug"></template>

<script>

export default {
  props: ['props'],
  data () {
    return {
      yelper: 'unknown',
      location: 'unknown'
    }
  },
  methods: {
    isYelper (value) {
      this.yelper = value
      console.log('yelper = ', this.yelper)
    },
    isLocation (value) {
      this.location = value
      console.log('location = ', this.location)
    }
  }
}
</script>



// WEBPACK FOOTER //
// custom-reviews-content.vue?7eb4dce6